module.exports = __webpack_public_path__ + "veterans-a28e068c.webp";